'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { clsx } from '@/libs';

type QuantitySelectButtonProps = HTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode;
};

export const QuantitySelectButton = ({
  children,
  className,
  ...props
}: QuantitySelectButtonProps) => {
  return (
    <button
      type="button"
      className={clsx(
        'w-11 h-full p-2.5 rounded-sm border-2 border-primary/10 bg-background flex items-center justify-center cursor-pointer',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
